var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z"}));
}

Menu.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Menu;

Menu.default = Menu;
